module.exports = __webpack_public_path__ + "static/media/plus.ac967f68.svg";